import fileDownload from 'js-file-download'

import type { PqCsvDownload } from '@/features/prequalification/localControl/types'

/**
 * Saves a CSV blob to disk, preferring the server-provided filename and
 * falling back to a caller-supplied name. Kept separate from the endpoint
 * functions so the real/mock download result is identical at the call site.
 *
 * Guards against an empty body so a soft failure (e.g. a 200 with no content)
 * surfaces as a caught error and a user alert instead of silently saving a
 * blank, plausibly-named file.
 */
export function triggerCsvDownload(download: PqCsvDownload, fallbackName: string): void {
  if (download.blob.size === 0) {
    throw new Error('CSV download was empty')
  }
  fileDownload(download.blob, download.filename ?? fallbackName)
}
